import { SlicePipe } from '@angular/common';
import { HttpStatusCode } from '@angular/common/http';
import { Component, inject, input, OnChanges, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SheydaProgramCardComponent } from '@components/cards/sheyda-program-card/sheyda-program-card.component';
import { ImageGeneratorComponent } from '@components/image-generator/image-generator.component';
import { ArtistInfo, Program } from '@shared/graphql/api.generated';
import { billboardSP } from '@shared/helper/responsive-sizes';
import { ArtistSeoService } from '@shared/seo/artist.seo.service';
import { ArtistService } from '@shared/services/artist.service';
import { GeneralService } from '@shared/services/general.service';
import { ProgramService } from '@shared/services/program.service';

@Component({
  imports: [SheydaProgramCardComponent, ImageGeneratorComponent, MatButtonModule, SlicePipe],
  providers: [ArtistService, ProgramService, ArtistSeoService],
  templateUrl: './artist.component.html',
  styleUrls: ['./artist.component.scss'],
})
export class ArtistComponent implements OnChanges {
  descriptor = input.required<string>();
  artist = signal<ArtistInfo | undefined>(undefined);
  programs = signal<Program[]>([]);
  isSeeMoreActive = signal(false);
  bioLength = signal(500);
  artistBannerSizes = billboardSP;

  private artistService = inject(ArtistService);
  private generalService = inject(GeneralService);
  private artistSeoService = inject(ArtistSeoService);
  private programService = inject(ProgramService);

  ngOnChanges() {
    this.getArtist();
  }

  getArtist() {
    this.artistService.getArtistByDescriptor(this.descriptor()).subscribe({
      next: (res) => {
        this.artist.set(res.data!);
        this.getPrograms();
        this.setSeoTags();
        this.artistSeoService.setArtistRelatedJsonLdScripts(res.data as ArtistInfo);
      },
      error: (e) => {
        if (e.networkError?.statusCode === HttpStatusCode.NotFound) {
          this.generalService.router.navigateByUrl('/error/404');
        }
      },
    });
  }

  getPrograms() {
    this.programService.getArtistPrograms(this.artist()?.id!).subscribe({
      next: (res) => {
        this.programs.set(res.data);
        this.artistSeoService.setMovieCarouselJsonLdScript(res.data);
      },
    });
  }

  setSeoTags() {
    if (this.artist) {
      this.artistSeoService.setSeoTags(this.artist()!);
    }
  }

  toggleBio() {
    this.bioLength.set(!this.isSeeMoreActive() ? this.artist()!.biography.length : 500);
    this.isSeeMoreActive.set(!this.isSeeMoreActive());
  }
}
